module.exports = __webpack_public_path__ + "b0322980fb24a9230fca37bc8906008d.png";